

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_hbx3g3mdoq = () => {
                    
                        if (document.querySelector('.beae-2fabrjs3:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-2fabrjs3:not([data-beae-bind])'),
                                
                                id: 'beae-2fabrjs3',
                                isLive: true
                            });
                            document.querySelector('.beae-2fabrjs3:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-dl5ze6ln:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-dl5ze6ln:not([data-beae-bind])'),
                                
                                id: 'beae-dl5ze6ln',
                                isLive: true
                            });
                            document.querySelector('.beae-dl5ze6ln:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-kfx2zmtf:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-kfx2zmtf:not([data-beae-bind])'),
                                
                                id: 'beae-kfx2zmtf',
                                isLive: true
                            });
                            document.querySelector('.beae-kfx2zmtf:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_hbx3g3mdoq()
                } else {
                    window.beaePageJS.push(jsHandle_hbx3g3mdoq)
                }
            